import React from 'react';
import { FlexView } from '@cuemath/comps';
import { Grid } from 'semantic-ui-react';

import {
  ApplicantProfileLabelWrapper,
  ApplicantProfileLinkWrapper,
  ApplicantProfileValueWrapper,
} from './styled-components';

const LinkContainer = (label, value, width) => {
  return (
    <Grid.Column width={width}>
      <ApplicantProfileLinkWrapper onClick={value}>{label}</ApplicantProfileLinkWrapper>
    </Grid.Column>
  );
};
LinkContainer.defaultProps = {
  label: '',
  value: () => {},
  width: 8,
};

const DetailsContainer = (label, value) => {
  return (
    <FlexView>
      <ApplicantProfileLabelWrapper weight="bold">{label}</ApplicantProfileLabelWrapper>
      <ApplicantProfileValueWrapper>{value}</ApplicantProfileValueWrapper>
    </FlexView>
  );
};

DetailsContainer.defaultProps = {
  label: '',
  value: '',
};

const FieldContainer = (label, value, width) => {
  return <Grid.Column width={width}>{DetailsContainer(label, value)}</Grid.Column>;
};

FieldContainer.defaultProps = {
  label: '',
  value: '',
  width: 8,
};

export { FieldContainer, LinkContainer };
